module.exports = __webpack_public_path__ + "img/bonus_symbol_3.6f0a1610.png";